export * from './detail.component'